export const createDropdownOptions = (data = [], labelKey = "label", valueKey = "value", isAllValue = false) => {
  const options = Array.isArray(data)
    ? data.map((item) => {
        if (typeof item === "object" && item !== null) {
          return {
            label: item[labelKey] ?? item[valueKey] ?? "",
            value: item[valueKey] ?? item[labelKey] ?? "",
          };
        }
        return { label: item, value: item };
      })
    : [];

  if (isAllValue) {
    return [{ label: "All", value: "ALL" }, ...options];
  }

  return options;
};
